import type { PackItem } from '../Home/DynamicHomepage/components/NewLayout/RafflePage/RafflePage';
import { byPriceAscending } from '../../utils/packItems';
import { startingBonusEntries } from './giveawayOfferPaymentPayload';

/* Which subscription plans the confirmation page offers, and the most one of
 * them starts a buyer with.
 *
 * TWO PLANS: the dearest and the second-cheapest, dearest first — Relic and Epic
 * on today's four-step ladder (Rare, Epic, Legendary, Relic), by request. They
 * are picked by POSITION in the price order, never by title: titles are data an
 * admin can edit, while the shape of the ladder has been stable. A shorter
 * ladder still gives two different plans, or the one there is.
 *
 * THE POPUP'S "UP TO" is the largest `startingBonusEntries` among the plans
 * shown — the figure their cards print as "start with N entries from the get
 * go" — so it can never promise more than the cards under it do.
 */

/** The dearest plan and the second-cheapest, dearest first; never one twice. */
export const offerPagePacks = (items: PackItem[]): PackItem[] => {
  const ladder = byPriceAscending(items);
  if (ladder.length < 2) return ladder;
  /* With two plans the second-cheapest IS the dearest, so the cheapest
   * partners it instead. */
  return [ladder[ladder.length - 1], ladder[ladder.length === 2 ? 0 : 1]];
};

/** The largest "start with N entries" bonus among `packs`; 0 when there are none. */
export const largestStartingBonus = (packs: PackItem[]) =>
  packs.reduce((most, pack) => Math.max(most, startingBonusEntries(pack)), 0);
